import React from "react";
import styled from "styled-components";
import { textGradient } from "../GradientBox";
import { LandingPageTemplate } from "./LandingTemplate";

export const BioageLiveLanding: React.FC = () => {
  return (
    <LandingPageTemplate
      header={<Header />}
      illustration={
        <img
          height={326}
          style={{
            marginTop: "-20px",
            marginBottom: "-20px",
          }}
          src="/landing-pages/bioage-live-illustration.png"
        />
      }
      androidStoreListing={"bioage_live"}
      appStorePpid={"cece62d9-fdbd-41be-8817-06e1aeb5da0c"}
    />
  );
};

export default BioageLiveLanding;

const Header: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <ContentHeader>
        Twój wiek
        <br />
        biologiczny
        <br />
        na żywo
      </ContentHeader>
    </div>
  );
};

const ContentHeader = styled.h1`
  font-size: 32px;
  font-weight: bold;
  background: ${textGradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0px;
`;
